import { getResourceName } from 'features/resources'
import { USER_CREDENTIALS_STATUS } from 'features/settings/utils'
import { reduxApiClient } from 'infra'
import React from 'react'
import { enqueueNotification } from 'Utils/Helpers'
import { FullScreenAlertModal } from 'V2Components'

export const ApproveUserCredentials = ({ userCredential, credKeyToApprove, onCancel }) => {
  const handleApprove = async () => {
    const data = structuredClone(userCredential)
    const map = data.PublicKeyCredentialMap.PublicKeyCredentialMap

    // approve status
    map[credKeyToApprove] = { ...map[credKeyToApprove], Status: USER_CREDENTIALS_STATUS.approved }
    data.PublicKeyCredentialMap.PublicKeyCredentialMap = map

    await reduxApiClient('user-credentials').update(data)
    enqueueNotification('Passkey has been approved successfully!', 'info')
    onCancel()
  }

  const name = getResourceName(userCredential)

  return (
    <FullScreenAlertModal
      actionButtonText='Approve'
      actionButtonVariant='primary'
      loadingMessage={`Approving Passkey`}
      showModal
      onActionClick={handleApprove}
      onCancel={onCancel}
      alertMessage={
        <>
          Are you sure you want to approve passkey of
          <strong className='mx-1' title={name}>
            {name.substring(0, 21)}
            {name.length > 21 && '...'}
          </strong>
          ?
        </>
      }
    />
  )
}
